/* eslint-disable */
export class RestApplicationClient {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * HTTP GET /application.wadl
     * Java method: org.glassfish.jersey.server.wadl.internal.WadlResource.getWadl
     */
    getWadl(options) {
        return this.httpClient.request({ method: "GET", url: uriEncoding `application.wadl`, copyFn: __identity(), options: options });
    }
    /**
     * HTTP GET /application.wadl/{path}
     * Java method: org.glassfish.jersey.server.wadl.internal.WadlResource.getExternalGrammar
     */
    getExternalGrammar(path, options) {
        return this.httpClient.request({ method: "GET", url: uriEncoding `application.wadl/${path}`, copyFn: __identity(), options: options });
    }
    /**
     * HTTP GET /health/started
     * Java method: no.eika.infrastruktur.jakarta.server.lib.HealthResource.started
     */
    started(options) {
        return this.httpClient.request({ method: "GET", url: uriEncoding `health/started`, copyFn: __identity(), options: options });
    }
    /**
     * HTTP POST /laaneramme
     * Java method: no.eika.kreditt.boliglaankalkulator.web.laaneramme.LaanerammeResource.getLaaneramme
     */
    getLaaneramme(arg0, options) {
        return this.httpClient.request({ method: "POST", url: uriEncoding `laaneramme`, data: arg0, copyFn: __identity(), options: options });
    }
    /**
     * HTTP GET /laaneramme/markedsrente
     * Java method: no.eika.kreditt.boliglaankalkulator.web.laaneramme.LaanerammeResource.getMarkedsrente
     */
    getMarkedsrente(options) {
        return this.httpClient.request({ method: "GET", url: uriEncoding `laaneramme/markedsrente`, copyFn: __identity(), options: options });
    }
    /**
     * HTTP GET /liveness/health
     * Java method: no.eika.infrastruktur.jakarta.server.lib.HealthResource.liveness
     */
    liveness(options) {
        return this.httpClient.request({ method: "GET", url: uriEncoding `liveness/health`, copyFn: __identity(), options: options });
    }
    /**
     * HTTP POST /log/{level}
     * Java method: no.eika.infrastruktur.jakarta.server.lib.FrontendLogResource.log
     */
    log(level, arg3, options) {
        return this.httpClient.request({ method: "POST", url: uriEncoding `log/${level}`, data: arg3, copyFn: __identity(), options: options });
    }
    /**
     * HTTP GET /readiness/status
     * Java method: no.eika.infrastruktur.jakarta.server.lib.HealthResource.readiness
     */
    readiness(options) {
        return this.httpClient.request({ method: "GET", url: uriEncoding `readiness/status`, copyFn: __identity(), options: options });
    }
}
function uriEncoding(template, ...substitutions) {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}
function __getCopyArrayFn(itemCopyFn) {
    return (array) => __copyArray(array, itemCopyFn);
}
function __copyArray(array, itemCopyFn) {
    return array && array.map(item => item && itemCopyFn(item));
}
function __getCopyObjectFn(itemCopyFn) {
    return (object) => __copyObject(object, itemCopyFn);
}
function __copyObject(object, itemCopyFn) {
    if (!object) {
        return object;
    }
    const result = {};
    for (const key in object) {
        if (object.hasOwnProperty(key)) {
            const value = object[key];
            result[key] = value && itemCopyFn(value);
        }
    }
    return result;
}
function __identity() {
    return value => value;
}
//# sourceMappingURL=data:application/json;base64,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